import React, { useState } from "react";
import {Grid } from '@material-ui/core';
import { Box, Card, CardContent, Alert, AlertTitle, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Autocomplete, Select, OutlinedInput, MenuItem } from '@mui/material';
import MainCard from '../components/MainCard';
import StickyHeadTwoButtonTable from '../components/StickyHeadTwoButtonTable';
import axios from "../../components/axios";
import CustomDatePicker from '../components/CustomDatePicker';
import { useNavigate } from 'react-router-dom';
import { format, isValid } from 'date-fns';
import Chip from "@material-ui/core/Chip";
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from "@material-ui/core/TextField";
import PieChartNoTable from '../components/Chart/PieChartNoTable';
import Checkbox from '@mui/material/Checkbox';

const TestAutomationFilterPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [clickCalendar, setclickCalendar] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [val, setVal] = useState([]);
  const [dialogValue, setDialogValue] = useState({id: '',value: ''});
  const [dialogSeleValue, setDialogSeleValue] = React.useState([]);
  const [showDialogText, setShowDialogText] = useState(false);
  const [showDialogAuto, setShowDialogAuto] = useState(false);
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [deleteItemID, setDeleteItemID] = useState('');
  const [dialogOptions, setDialogOptions] = useState([]);
  const [noDataMessage, setNoDataMessage] = useState('');
  const threshold = 1000;
  const exportURL = '/peloton/v1/automation/filter-test-csv';
  const shareAPI = 'share-link';
  const [fullQuery, setFullQuery] = useState('');
  const [openSummary, setOpenSummary] = useState(false);
  const [series, setSeries] = useState([]);
  const [total, setTotal] = useState(0);
  const [pass, setPass] = useState(0);
  const [fail, setFail] = useState(0);
  const [skip, setSkip] = useState(0);
  const [checkOTA, setCheckOTA] = useState(false);
  const showShare = true;
  const showSummary = true;

const handleClose = () => {
    setDialogValue({id: '',value: ''});
    setOpenDialog(false);
    setOpenSummary(false);
  };

const handleSubmit = (event) => {
    event.preventDefault();
    if (dialogValue.id === "serial_number"){
      setVal(val.concat({id: dialogValue.id, value: dialogValue.value}))
    }else{
      setVal(val.concat({id: dialogValue.id, value: dialogSeleValue}))
    }
    handleClose();
  };

  const [open, setOpen] = useState(false);
  const onChange = (ranges) => {
    if (clickCalendar === 0 ){
      setclickCalendar(clickCalendar+1)
    }else{
      setclickCalendar(0)
      if (ranges.startDate !== null && ranges.endDate !== null) {
        setOpen(false);
      }
    }
  };

  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection"
    }
  ]);

  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
};

  const handleDownload = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid })
      axios.post("/peloton/v1/automation/test-report-file", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(response.data.url, "_blank");
        }else{
            alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleRedirect = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid });
      axios.post("/peloton/v1/automation/test-report-pages", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(process.env.REACT_APP_API_URL+response.data.url, "_blank");
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleDelete = (row) => {
    setDeleteItemID(row.uuid);
    setShowDialogDelete(true);
  };

  const deleteTestRecord = () => {
    var input_data = JSON.stringify({ item_uuid: deleteItemID });
      axios.post("/peloton/v1/automation/remove-test-record", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          handleQueryData()
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
    })
    .finally(() => {
      setDeleteItemID('');
      setShowDialogDelete(false);
    });
  }

  const handleQueryData = () => {
     let queryFields = val.map((option, index) => {
        return ({ field: option.id, value: option.value.toString()})
      });

    if ( queryFields.length === 0 && state[0].startDate === null && state[0].endDate === null ){
        alert("Please select query date range or keyword!");
    }else{
      setTotal(0);
      setPass(0);
      setFail(0);
      setSkip(0);
      setSeries([]);
      setRows([]);
      let startDateStr = "";
      let endDateStr = ""
      if (state[0].startDate !== null && isValid(state[0].startDate)) {
        startDateStr = format(state[0].startDate, "yyyy-MM-dd")
      }
      if (state[0].endDate !== null && isValid(state[0].endDate)) {
        endDateStr = format(state[0].endDate, "yyyy-MM-dd")
      }

      var input_data = JSON.stringify({ query: queryFields, start_date: startDateStr, end_date: endDateStr, is_ota:'0'})
      setFullQuery(input_data);
      let url = "/peloton/v1/automation/filter-test-report"
      if (checkOTA) {
        url = "/peloton/v1/automation/filter-ota-report"
      }
      axios.post(url, input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          if (response.data.data !== null && response.data.data.length > 0){
            if (response.data.data.length >threshold){
                setshowAlert(true);
                setNoDataMessage('More than 1000 rows, please click "Export Data" to download file')
            }else{
              setRows(response.data.data);
              setshowAlert(false);
            }
            setTotal(response.data.total_count);
            setPass(response.data.pass_count);
            setFail(response.data.fail_count);
            setSkip(response.data.skip_count);
            setSeries([response.data.pass_count, response.data.fail_count, response.data.skip_count]);
            setshowTable(true);
            //setVal([]);
          }else{
            setNoDataMessage('No data in this condition.')
            setshowAlert(true);
          }
        }else{
          alert(response.data.message);
        }
      }).catch(error => {
        if (error.message === 'timeout of 3000ms exceeded'){
          setshowAlert(true);
          setNoDataMessage('Too many rows, please click "Export Data" to download file')
          setshowTable(true);
          //setVal([]);
        }else{
          if (!error.response){
            alert(error)
          }else{
            if (error.response.status === 401){
              navigate("/");
            }else{
              alert(error.response.data.message);
            }
          }
        }
      })
    }
  };

  const handleGetOptions = (fieldName) => {
      let queryFields = val.map((option, index) => {
        return ({ field: option.id, value: option.value.toString()})
      });

      var input_data = JSON.stringify({ field: fieldName, query: queryFields})
      let url = "/peloton/v1/automation/test-report-options"
      if (checkOTA) {
        url = "/peloton/v1/automation/ota-report-options"
      }
      axios.post(url, input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          if (response.data.options !== null){
            setDialogOptions(response.data.options);
          }
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err)
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const styleChip = {
        marginTop: "3px",
        marginRight: "3px",
  };

  const handleSummary = () => {
    setOpenSummary(true)
  };

const columns = [
  { id: 'serial_number', label: 'Serial Number', align: 'left' },
  { id: 'affernet', align: 'center', label: 'Affernet'},
  { id: 'dm', align: 'center', label: 'DM'},
  { id: 'start_time', align: 'center', label: 'Start Time'},
  { id: 'end_time', align: 'center', label: 'End Time'},
  { id: 'OTA_service', align: 'center', label: 'OTA service'},
  { id: 'fw_updater', align: 'center', label: 'FW Updater'},
  { id: 'home_app', align: 'center', label: 'Home App'},
  { id: 'platform', align: 'center', label: 'platform'},
  { id: 'suite_name', align: 'center', label: 'Suite Name'},
  { id: 'system_image', align: 'center', label: 'System Image'},
  { id: 'system_image_type', align: 'center', label: 'Image Type'},
  { id: 'total', align: 'center', label: 'Total'},
  { id: 'pass', align: 'center', label: 'Pass'},
  { id: 'fail', align: 'center', label: 'Fail'},
  { id: 'skip', align: 'center', label: 'Skip'},
  { id: 'action', label: 'Download', align: 'center', action: true},
  { id: 'view', label: 'Show', align: 'center', view: true },
  { id: 'ignore', label: 'Ignore', align: 'center', ignore: true },
];

const fields = [
  { id: 'serial_number'},
  { id: 'affernet'},
  { id: 'dm'},
  { id: 'OTA_service'},
  { id: 'fw_updater'},
  { id: 'home_app'},
  { id: 'platform'},
  { id: 'suite_name'},
  { id: 'system_image'},
  { id: 'system_image_type'},
  { id: 'result'},
];

  const valHtml = val.map((option, index) => {
    const label = option.id || option;
    const value = option.value || '';
    return (
      <Chip
      style={styleChip}
        key={label}
        label={label+':'+value}
        deleteIcon={<DeleteIcon />}
        color="primary"
        variant="outlined"
        size="small"
        onDelete={() => {
          setVal(val.filter(entry => entry !== option))
        }}
      />
    );
  });

  const handleOnChange = (newValue) => {
    if (newValue.length === 0 ){
      setVal([]);
    }else{
      setOpenDialog(true);
      setDialogValue({id: newValue[newValue.length-1].id,value: ''})
      setDialogSeleValue([])
      if (newValue[newValue.length-1].id === 'serial_number') {
        setShowDialogText(true)
        setShowDialogAuto(false)
      } else {
        handleGetOptions(newValue[newValue.length-1].id)
        setShowDialogText(false)
        setShowDialogAuto(true)
      }
    }
  }

  const handleDialogOptionOnChange = (event) => {
    const {
      target: { value },
    } = event;
    setDialogSeleValue(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleCheckChange = (event) => {
    setCheckOTA(event.target.checked);
    setVal([]);
  };

  const handleDeleteClose = () => {
    setShowDialogDelete(false);
  };

  return (
    <MainCard title="Key Filter">
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
      Key Filter
      </Box>
      <Grid container direction="row" justifyContent="space-around" alignItems="center">
        <Grid item xs={4}>
        <CustomDatePicker onChange={onChange} open={open} setOpen={setOpen} state={state} setState={setState}/>
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            checked={checkOTA}
            onChange={handleCheckChange}
            inputProps={{ 'aria-label': 'primary checkbox' }}
            sx={{
              color: "#406599",
              '&.Mui-checked': {
                color: "#406599",
              },
            }}
          />OTA only
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            multiple
            id="fields"
            freeSolo
            filterSelectedOptions
            options={fields}
            onChange={(e, newValue) => handleOnChange(newValue)}
            getOptionLabel={option => option.id}
            renderTags={() => {}}
            value={val}
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                placeholder="Add Filter"
                margin="normal"
                fullWidth
              />
            )}
          />
          <div className="selectedTags">{valHtml}</div>
      <Dialog open={openDialog} onClose={handleClose} fullWidth>
        <form onSubmit={handleSubmit}>
          <DialogTitle>Add new field</DialogTitle>
          <DialogContent>
          <Grid container direction="row" justifyContent="space-around" alignItems="center" >
            <Grid item xs={4}>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              value={dialogValue.id}
              onChange={(event) =>
                setDialogValue({
                  ...dialogValue,
                  value: event.target.value,
                })
              }
              label="Field"
              type="text"
              variant="standard"
            />
            </Grid>
            <Grid item xs={4}>
            {showDialogText && (<TextField
              margin="dense"
              id="name"
              value={dialogValue.value}
              onChange={(event) =>
                setDialogValue({
                  ...dialogValue,
                  value: event.target.value,
                })
              }
              label="value"
              type="text"
              variant="standard"
            />)}

            {showDialogAuto && (<Select
              id="tags-standard"
              sx={{ width: 230 }}
              multiple
              value={dialogSeleValue}
              onChange={handleDialogOptionOnChange}
              input={<OutlinedInput id="select-multiple-chip" label="value" />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {dialogOptions.map((data) => (
                <MenuItem
                  key={data.value}
                  value={data.value}
                >
                  {data.value}
                </MenuItem>
              ))}
            </Select>)}
            </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add</Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog open={openSummary} onClose={handleClose} fullWidth>
        <PieChartNoTable series={series} total={total} pass={pass} fail={fail} skip={skip} fullQuery={fullQuery} isShareable={true} shareAPI={shareAPI}/>
      </Dialog>
      <Dialog open={showDialogDelete} onClose={handleDeleteClose} fullWidth>
        <DialogTitle id="alert-dialog-title">
          {"Confirm delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to ignore this test record ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose}>Cancel</Button>
          <Button onClick={deleteTestRecord} autoFocus>
            Ignore
          </Button>
        </DialogActions>
      </Dialog>
        </Grid>
        <Grid item xs={1}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      { showTable && (<StickyHeadTwoButtonTable rows={rows} columns={columns} handleDownload={handleDownload} handleRedirect={handleRedirect} exportURL={exportURL} fullQuery={fullQuery} showSummary={showSummary} handleSummary={handleSummary} showShare={showShare} shareAPI={shareAPI} handleDelete={handleDelete}/>)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        {noDataMessage}
      </Alert></Card>)}
    </MainCard>)
};

export default TestAutomationFilterPage;
